/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_ExperimentInputs */

const th_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทดสอบสื่อสำหรับสองคน โปรดใช้หูฟัง นี่ไม่ใช่บริการประชุมส่วนตัว`)
};

const en_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two-person media test. Use headphones. This is not a private meeting service.`)
};

const ja_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2人用のメディアテストです。ヘッドホンをご利用ください。非公開の会議サービスではありません。`)
};

const zh_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双人媒体测试。请使用耳机。这不是私密会议服务。`)
};

const es_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba de audio y vídeo para dos personas. Usa auriculares. Esto no es un servicio de reuniones privadas.`)
};

const pt_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste de áudio e vídeo para duas pessoas. Use fones. Isto não é um serviço de reuniões privadas.`)
};

const id_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uji media dua kursi. Pakai headphone. Ini bukan layanan pertemuan privat.`)
};

const fr_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test audio et vidéo à deux. Utilisez un casque. Ce n’est pas un service de réunion privée.`)
};

const tl_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagsubok sa media para sa dalawa. Gumamit ng headphone. Hindi ito pribadong serbisyo ng miting.`)
};

const vi_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử nghiệm media hai chỗ. Dùng tai nghe. Đây không phải dịch vụ họp riêng tư.`)
};

const ko_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2인 미디어 테스트입니다. 헤드폰을 사용하세요. 비공개 회의 서비스가 아닙니다.`)
};

const de_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medientest zu zweit. Nutze Kopfhörer. Das ist kein privater Meeting-Dienst.`)
};

const ru_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка медиа на двоих. Используйте наушники. Это не приватный сервис встреч.`)
};

const tr_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İki kişilik medya testi. Kulaklık kullanın. Bu özel bir toplantı hizmeti değildir.`)
};

const it_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova dei media a due. Usa le cuffie. Non è un servizio di riunioni private.`)
};

const pl_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test mediów na dwie osoby. Użyj słuchawek. To nie jest prywatna usługa spotkań.`)
};

const uk_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перевірка медіа на двох. Скористайтеся навушниками. Це не приватний сервіс зустрічей.`)
};

const hi_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दो लोगों का मीडिया परीक्षण। हेडफ़ोन का उपयोग करें। यह निजी बैठक सेवा नहीं है।`)
};

const ar_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختبار وسائط لشخصين. استخدم سماعات. هذه ليست خدمة اجتماعات خاصة.`)
};

const ms_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ujian media dua orang. Gunakan fon kepala. Ini bukan perkhidmatan mesyuarat peribadi.`)
};

const bn_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দুজনের মিডিয়া পরীক্ষা। হেডফোন ব্যবহার করুন। এটি ব্যক্তিগত সভার পরিষেবা নয়।`)
};

const zh_tw2_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`雙人媒體測試。請使用耳機。這不是私人會議服務。`)
};

const zh_hk2_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`雙人媒體測試。請使用耳機。這不是私人會議服務。`)
};

const ur_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دو افراد کا میڈیا ٹیسٹ۔ ہیڈ فون استعمال کریں۔ یہ نجی ملاقات کی سروس نہیں۔`)
};

const fa_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آزمون رسانه برای دو نفر. از هدفون استفاده کنید. این سرویس جلسهٔ خصوصی نیست.`)
};

const sw_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaribio la sauti na picha kwa watu wawili. Tumia vipokea sauti. Hii si huduma ya mikutano ya faragha.`)
};

const nl_meeting_test_experiment = /** @type {(inputs: Meeting_Test_ExperimentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediatest voor twee. Gebruik een koptelefoon. Dit is geen dienst voor privégesprekken.`)
};

/**
* | output |
* | --- |
* | "Two-person media test. Use headphones. This is not a private meeting service." |
*
* @param {Meeting_Test_ExperimentInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_experiment = /** @type {((inputs?: Meeting_Test_ExperimentInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_ExperimentInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_experiment(inputs)
	if (locale === "ja") return ja_meeting_test_experiment(inputs)
	if (locale === "zh") return zh_meeting_test_experiment(inputs)
	if (locale === "es") return es_meeting_test_experiment(inputs)
	if (locale === "pt") return pt_meeting_test_experiment(inputs)
	if (locale === "id") return id_meeting_test_experiment(inputs)
	if (locale === "fr") return fr_meeting_test_experiment(inputs)
	if (locale === "tl") return tl_meeting_test_experiment(inputs)
	if (locale === "vi") return vi_meeting_test_experiment(inputs)
	if (locale === "ko") return ko_meeting_test_experiment(inputs)
	if (locale === "de") return de_meeting_test_experiment(inputs)
	if (locale === "ru") return ru_meeting_test_experiment(inputs)
	if (locale === "tr") return tr_meeting_test_experiment(inputs)
	if (locale === "it") return it_meeting_test_experiment(inputs)
	if (locale === "pl") return pl_meeting_test_experiment(inputs)
	if (locale === "uk") return uk_meeting_test_experiment(inputs)
	if (locale === "hi") return hi_meeting_test_experiment(inputs)
	if (locale === "ar") return ar_meeting_test_experiment(inputs)
	if (locale === "ms") return ms_meeting_test_experiment(inputs)
	if (locale === "bn") return bn_meeting_test_experiment(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_experiment(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_experiment(inputs)
	if (locale === "ur") return ur_meeting_test_experiment(inputs)
	if (locale === "fa") return fa_meeting_test_experiment(inputs)
	if (locale === "sw") return sw_meeting_test_experiment(inputs)
	if (locale === "nl") return nl_meeting_test_experiment(inputs)
	return en_meeting_test_experiment(inputs)
});